<app-breadcrumb *ngIf="!deregistrationPack" [master]="'Rejestracje'" [parentName]="'Wyrejestrowania'" [name]="'Dodaj'"></app-breadcrumb>
<div class="deregistration-pack-add" fxLayout="column" fxLayoutGap="15px"  >
  <div class="status-info" *ngIf="deregistrationPack">
    <app-dict
      [label]="'Status'" [dictType]="'deregistration_pack_status'"
      [control]="statusControl"
      [required]="true"
      [multiple]="false"
      appearance="fill"
      [color]="true"
    ></app-dict>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!deregistrationPackForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane paczki</h3>
        </div>

        <div fxLayout="row" *ngIf="!deregistrationPack">
          <app-dict-insurance-companies fxFlex="100" label="TU" [control]="insuranceCompanyControl" [required]="true"></app-dict-insurance-companies>
        </div>

        <div fxLayout="row" *ngIf="deregistrationPackObject">
          <app-detail fxFlex="100" header="TU" [value]="deregistrationPackObject.insuranceCompany?.name"></app-detail>
        </div>

        <div fxLayout="row" *ngIf="!deregistrationPack">
          <app-dict fxFlex="100" label="Firma" [control]="companyControl" [required]="true" dictType="company"></app-dict>
        </div>

        <div fxLayout="row" *ngIf="deregistrationPackObject">
          <app-detail fxFlex="100" header="Firma" [value]="deregistrationPackObject.company?.name"></app-detail>
        </div>

      </mat-card>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column" *ngIf="deregistrationPack">
      <mat-card>
        <div fxLayout="row">
          <h3>Szczegóły</h3>
        </div>

        <div fxLayout="row">
          <app-datepicker fxFlex="100"
                          label="Data wysłania"
                          placeholder="2000-01-01"
                          [required]="false"
                          [control]="sentAtControl"
          ></app-datepicker>
        </div>

        <div fxLayout="row">
          <app-detail fxFlex="100" header="Data utworzenia" [value]="deregistrationPackObject.createdAt | date:'y-MM-dd'"></app-detail>
        </div>

      </mat-card>

    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!deregistrationPackForm.valid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
